export type CreateInterfaceDeploymentRequestRequest = {
  processTyp: string;
  dfnSetVerNum: string;
  pjtId: string;
  dplyImplType: string;
  dplymntDtime: string;
  forceStgDplyFlg: boolean;
  ifList: Interface[];
};

type Interface = {
  interfaceRequirementId: string;
  updateDTimeTIfReq: string;
  srcDstType: string;
  tcktId: string;
  pendingFlag?: boolean;
};
